export default __webpack_public_path__ + "static/media/IconAssignments.75fdc389.png";